document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutationsList, observer) => {
    const productItems = document.querySelectorAll(".product-grid");
    if (productItems.length > 0) {
      initializeProductGrid();
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true, 
  });
});

function initializeProductGrid() {
  const productItems = document.querySelectorAll(".product-grid .grid__item");
  productItems.forEach((productItem) => {
    const primaryImageList = Array.from(
      productItem.querySelectorAll(".product-item__primary-image")
    );

    productItem.addEventListener("change", function (event) {
      if (
        event.target.matches(
          ".product-item-meta__swatch-list .color-swatch__radio"
        )
      ) {
        onColorSwatchChanged(
          event,
          event.target,
          productItem,
          primaryImageList
        );
      }
    });

    productItem.addEventListener(
      "mouseenter",
      function (event) {
        if (
          event.target.matches(
            ".product-item-meta__swatch-list .color-swatch__item"
          )
        ) {
          onColorSwatchHovered(event, event.target, primaryImageList);
        }
      },
      true
    );
  });

  async function onColorSwatchChanged(
    event,
    target,
    productItem,
    primaryImageList
  ) {
    Array.from(productItem.querySelectorAll("a[href*='/products']")).forEach(
      (link) => {
        let url;
        if (link.tagName === "A") {
          url = new URL(link.href);
        } else {
          url = new URL(
            link.getAttribute("href"),
            `https://${window.themeVariables.routes.host}`
          );
        }
        url.searchParams.set("variant", target.getAttribute("data-variant-id"));
        link.setAttribute("href", url.toString());
      }
    );

    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = primaryImageList.find(
        (image) =>
          image.getAttribute("data-media-id") ===
          target.getAttribute("data-variant-featured-media")
      );
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete
        ? Promise.resolve()
        : new Promise((resolve) => (newImage.onload = resolve));
      await onImageLoaded;
      newImage.removeAttribute("hidden");

      let properties = {};
      if (
        Array.from(newImage.parentElement.classList).some((item) =>
          [
            "aspect-ratio--short",
            "aspect-ratio--tall",
            "aspect-ratio--square",
          ].includes(item)
        )
      ) {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1,
          },
        ];
      } else {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1,
          },
        ];
      }

      await newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out",
      }).finished;

      primaryImageList
        .filter(
          (image) =>
            image.classList.contains("product-item__primary-image") &&
            image !== newImage
        )
        .forEach((image) => image.setAttribute("hidden", ""));
    }
  }

  function onColorSwatchHovered(event, target, primaryImageList) {
    const input = target.previousElementSibling;
    if (input.hasAttribute("data-variant-featured-media")) {
      const newImage = primaryImageList.find(
        (image) =>
          image.getAttribute("data-media-id") ===
          input.getAttribute("data-variant-featured-media")
      );
      newImage.setAttribute("loading", "eager");
    }
  }
}
